import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { HttpErrorResponse } from '@angular/common/http';
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  QueryList,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import {
  MatAutocomplete,
  MatAutocompleteSelectedEvent,
} from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { MatDialog } from '@angular/material/dialog';
import { FileTypeT3 } from 'src/app/core/enums/user/file-type';
import { SelfAssessmentDocumentModel } from 'src/app/core/models/self-assessment/self-assessment-document-model';
import { SelfAssessmentCkDataSaveModel } from 'src/app/core/models/self-assessmentT2/update-self-assessmentT2-model';
import { SelfAssessmentJudgement } from 'src/app/core/models/self-assessmentT3/SelefassessmentJudgement';
import { SelfAssessmentT3ApproachDto } from 'src/app/core/models/self-assessmentT3/SelfAssessmentApproach';
import {
  SelfAssessmentInterpretation,
  userDropdownDto,
} from 'src/app/core/models/self-assessmentT3/SelfAssessmentInterpretation';
import { rightsManagementSAT3Dto } from 'src/app/core/models/self-assessmentT3/SelfAssessmentT3Filter';
import { SelfAssessmentCkDataSaveT3Dto } from 'src/app/core/models/self-assessmentT3/overall-aseesment';
import { overallAssessmentDropdownList } from 'src/app/core/models/self-assessmentT3/overallDropdownList';
import { conditionalApprovalAssessmentData } from 'src/app/core/models/self-assessmentT3/saveDataModel';
import { VersionHistoryT3DataDto } from 'src/app/core/models/self-assessmentT3/version-filter-viewT3-model';
import { ckEditorBroadcastMessage } from 'src/app/core/models/signalR/ckEditorBroadcastMessage';
import { UserProfile } from 'src/app/core/models/user';
import { ToastViewModel } from 'src/app/core/models/view-model';
import { GlobalService } from 'src/app/core/services/global/global.service';
import { SelfAssessmentTemplate3Service } from 'src/app/core/services/self-assessment-template3/self-assessment-template3.service';
import { SignalRService } from 'src/app/core/services/signalR/signal-r.service';
import { MasterHelper } from 'src/app/core/utilities';
import { ModalDialogComponent } from 'src/app/views/distributed-ui-components/modal-dialog/modal-dialog.component';
import { CkEditorRevisionComponent } from 'src/app/views/shared/ck-editor-revision/ck-editor-revision.component';

@Component({
  selector: 'app-conditional-approval',
  templateUrl: './conditional-approval.component.html',
  styleUrls: ['./conditional-approval.component.scss'],
})
export class ConditionalApprovalComponent {
  @Input() summaryDetailsId: number = 0;
  @Input() user: UserProfile = new UserProfile();
  @Input() selfAssessmentDocument: SelfAssessmentDocumentModel[] = [];
  @Input() tab!: number;
  @Input() versionHistoryData!: VersionHistoryT3DataDto;
  isButtonDisabled: boolean = false;
  @Input() interpretationAssessmentDropdownList: overallAssessmentDropdownList =
    new overallAssessmentDropdownList();
  @Output() onChildVariableChangeInterpretationT3: EventEmitter<any> =
    new EventEmitter<any>();
  @Output() onEditorSaveInterPretationT3: EventEmitter<any> =
    new EventEmitter<any>();
  interpretationEvidanceLoader: boolean = false;
  toastModel: ToastViewModel = new ToastViewModel();
  isToastShow: boolean = false;
  @Input() assessmentData!: any;
  @Input() tabName: string = '';
  @Output() parentDataChange = new EventEmitter<any>();

  searchActionOwnerCntrl: FormControl = new FormControl();
  @ViewChild('actionOwnerAutoComplete')
  actionOwnerAutoComplete!: MatAutocomplete;
  @ViewChild('approverInput')
  approverInput!: ElementRef<HTMLInputElement>;
  @ViewChildren(CkEditorRevisionComponent) ckEditorComponent:
    | QueryList<CkEditorRevisionComponent>
    | undefined;
  @Output() afterSave = new EventEmitter<void>();
  actionOwnerFilterList!: userDropdownDto[];
  searchedActionOwners: userDropdownDto[] = [];
  actionOwnerList: userDropdownDto[] = [];
  selectedApprovers: string[] = [];
  separatorKeysCodes: number[] = [ENTER, COMMA];

  private _childData!: any;
  get childData(): any {
    return this._childData;
  }
  set childData(value: any) {
    this._childData = value;
    this.parentDataChange.emit(value);
  }
  constructor(
    private _selfAssessment3Service: SelfAssessmentTemplate3Service,
    public dialog: MatDialog,
    private _signalRService: SignalRService,
    private ref: ChangeDetectorRef,
    private _globalService: GlobalService
  ) { }
  userPermissionList!: rightsManagementSAT3Dto;
  async ngOnInit() {
    // this._globalService.condApproverDropdownVariable$.subscribe(() => {
    //   this.filterActionOwnerWithoutSelectedItem();
    // });

    this.actionOwnerList = this.interpretationAssessmentDropdownList.actionOwner;
    this.searchedActionOwners = this.actionOwnerList;
    // this.actionOwnerFilterList = this.assessmentData.actionOwner?.split(',')?.map((x: string)=>{
    //   return {
    //     name: x,
    //     value: x,
    //     geography: null
    //   }
    // });
    this.startFilterDropdownFieldFn();
    this.filterActionOwnerWithoutSelectedItem();
    this.userPermissionList = await this._globalService.getUserPermissionList(
      this.assessmentData.id,
      this.versionHistoryData.isVersonHistory,
      this.user,
      this.assessmentData.summaryDetailsId,
      this.tabName
    );
  }
  removeActionOwner(value: string) {
    if (this.actionOwnerFilterList && this.actionOwnerFilterList.length > 0) {
      const index = this.actionOwnerFilterList.findIndex(
        (obj: userDropdownDto) => obj.value == value
      );
      if (index >= 0) {
        this.actionOwnerFilterList.splice(index, 1);
        this.assessmentData.actionOwner = this.actionOwnerFilterList.map(x => x.name).join(',');
      }
      this.filterActionOwnerWithoutSelectedItem();
      //this._globalService.setsubmitterDropdownVariable();
      // this._globalService.setReviewDropdownVariable();
      //this._globalService.setAppprovDropdownVariable();
    }
  }
  startFilterDropdownFieldFn() {
    this.searchActionOwnerCntrl.valueChanges.subscribe((term: any) => {
      // this.searchedActionOwners = term
      //   ? this.filterApproversName(term)
      //   : this.searchedActionOwners;
      this.searchedActionOwners = this.filterApproversName(term);
    });
  }
  filterApproversName(search: string) {
    // return this.searchedActionOwners.filter((option) =>
    //   option.name.toLowerCase().includes(search.toLowerCase())
    // );
    const normalizedExcludedOptions = (this.actionOwnerFilterList ?? []).map(option => option.value.toLowerCase());
    if (search) {
      return this.actionOwnerList.filter((option) =>
        option.value.toLowerCase().includes(search.toLowerCase())
        &&
        !normalizedExcludedOptions.includes(option.value.toLowerCase())
      );
    }
    else {
      return this.actionOwnerList.filter((option) =>
        !normalizedExcludedOptions.includes(option.value.toLowerCase())
      );
    }
  }
  addActionOwner(event: MatChipInputEvent) {
    const value = event.value;
    if (!this.actionOwnerAutoComplete.isOpen) {
      if ((value || '').trim()) {
        let sameValueRow = this.actionOwnerFilterList?.find(
          (option: userDropdownDto) => option.value == value
        );
      }
      this.filterActionOwnerWithoutSelectedItem();
      event.chipInput!.clear();
      this.searchActionOwnerCntrl.setValue(null);
    }
  }
  filterActionOwnerWithoutSelectedItem() {
    const selectedSubmitterName = this._globalService.selectedSubmitterName;
    const selectedReviewerName = this._globalService.selectedReviewerName;
    const selectedApproverName = this._globalService.selectedApproverName;
    this._globalService.selectedCondApproverName = this.actionOwnerFilterList;
    if (this.actionOwnerFilterList && this.actionOwnerFilterList.length > 0) {
      this.searchedActionOwners = this.actionOwnerList.filter(
        (obj: userDropdownDto) => !this.actionOwnerFilterList.some((filterObj: userDropdownDto) => filterObj.value === obj.value)
      );
    } else {
      this.searchedActionOwners = this.actionOwnerList;
    }
    // if (selectedSubmitterName) {
    //   this.searchedActionOwners = this.searchedActionOwners.filter((obj: userDropdownDto) => obj.name != selectedSubmitterName); // all dropdown accept selected name in submitter name
    // }
    // if (selectedReviewerName && selectedReviewerName.length > 0) {
    //   this.searchedActionOwners = this.searchedActionOwners.filter((obj: userDropdownDto) =>
    //     !selectedReviewerName.some((filterObj: userDropdownDto) => filterObj.value === obj.value)
    //   );
    // }
    // if (selectedApproverName && selectedApproverName.length > 0) {
    //   this.searchedActionOwners = this.searchedActionOwners.filter((obj: userDropdownDto) =>
    //     !selectedApproverName.some((filterObj: userDropdownDto) => filterObj.value === obj.value)
    //   );
    // }
  }
  selectedActionOwnerEvent(event: MatAutocompleteSelectedEvent) {
    if (this.actionOwnerFilterList) {
      let sameValueRow = this.actionOwnerFilterList.filter(
        (option: userDropdownDto) => option.name == event.option.viewValue
      );
      if (sameValueRow.length == 0) {
        this.addActionOwnerFilterListFn(event.option.viewValue);
      }
    } else {
      this.actionOwnerFilterList = [];
      this.addActionOwnerFilterListFn(event.option.viewValue);
    }
    if (this.approverInput) {
      this.approverInput.nativeElement.value = '';
    }
    this.searchActionOwnerCntrl.setValue(null);
    this.searchActionOwnerCntrl.disable();
    this.searchActionOwnerCntrl.enable();
    this.filterActionOwnerWithoutSelectedItem();
    //this._globalService.setsubmitterDropdownVariable();
    //this._globalService.setReviewDropdownVariable();
    //this._globalService.setAppprovDropdownVariable();
  }
  addActionOwnerFilterListFn(matchString: string) {
    let selectedValue: userDropdownDto | undefined = this.actionOwnerList.find(
      (option) => option.name == matchString
    );
    if (selectedValue) {
      this.actionOwnerFilterList.push(selectedValue);
      this.assessmentData.actionOwner = this.actionOwnerFilterList.map(x => x.name).join(',');
    }
  }

  async onChildVariableChangeMainT3(data: any, type: string) {
    if (type == 'ActionDetails') {
      this.assessmentData.actionDetails = data;
      this.assessmentData.muteActionDetailsUsers = await this.updateUserList(
        this.assessmentData.muteActionDetailsUsers,
        this.user.fullName
      );
    } else if (type == 'ActionClosure') {
      this.assessmentData.actionClosure = data;
      this.assessmentData.muteActionClosureUsers = await this.updateUserList(
        this.assessmentData.muteActionClosureUsers,
        this.user.fullName
      );
    }
    this.ref.detectChanges();
  }
  async updateUserList(userlist: string, newUser: string): Promise<string> {
    if (userlist) {
      const userList: string[] = userlist.split(',');
      const isPresent: boolean = userList.includes(newUser);
      if (!isPresent) {
        userList.push(newUser);
      }
      userlist = userList.join(',');
    } else {
      userlist = newUser;
    }
    return userlist;
  }
  onEditorSaveMainT3(data: SelfAssessmentCkDataSaveModel) {
    let payloadData: SelfAssessmentCkDataSaveT3Dto =
      new SelfAssessmentCkDataSaveT3Dto(
        data.ckData,
        data.ckName,
        data.selfAssessmentT2Id,
        this.assessmentData.id,
        data.userName
      );
    if (this.tabName == 'Interpretation') {
      this._selfAssessment3Service
        .updateSelfAssessmentCKForInterpretationT3(payloadData)
        .subscribe((res: any) => {
          this.alertMessage('success', ' Saved successfully');
          setTimeout(() => { }, 3500);
          this.notifyParentCkEditorChnage();
        });
    } else if (this.tabName == 'Judgement') {
      this._selfAssessment3Service
        .updateSelfAssessmentCKForJudgementT3(payloadData)
        .subscribe((res: any) => {
          this.alertMessage('success', ' Saved successfully');
          setTimeout(() => { }, 3500);
          this.notifyParentCkEditorChnage();
        });
    } else if (this.tabName == 'Approach') {
      this._selfAssessment3Service
        .updateSelfAssessmentCKForApproachT3(payloadData)
        .subscribe((res: any) => {
          this.alertMessage('success', ' Saved successfully');
          setTimeout(() => { }, 3500);
          this.notifyParentCkEditorChnage();
        });
    }
  }

  uploadEvidenceInterpretationForAction() {
    if (this.userPermissionList?.UplEvdAction) {
      const fileInput = document.getElementById(
        'uploadEvidanceT3ForAction'
      ) as HTMLElement;
      fileInput.click();
    }
  }
  handleFileInputForAction(files: FileList) {
    if (this.tabName == 'Interpretation') {
      for (let i = 0; i < files.length; i++) {
        this.uploadFileToActivityForReview(
          files[i],
          FileTypeT3.InterpretationAction
        );
      }
    } else if (this.tabName == 'Judgement') {
      for (let i = 0; i < files.length; i++) {
        this.uploadFileToActivityForReview(
          files[i],
          FileTypeT3.JudgementAction
        );
      }
    } else if (this.tabName == 'Approach') {
      for (let i = 0; i < files.length; i++) {
        this.uploadFileToActivityForReview(files[i], FileTypeT3.ApproachAction);
      }
    }
  }
  uploadFileToActivityForReview(fileToUpload: any, fileType: FileTypeT3) {
    this.interpretationEvidanceLoader = true;
    if (this.tabName == 'Interpretation') {
      this._selfAssessment3Service
        .UploadEvidenceInterpretationT3(
          fileToUpload,
          fileType,
          this.assessmentData.id.toString()
        )
        .subscribe(
          (data: any) => {
            this.fetchSelfAssessmentDocuments();
            this.interpretationEvidanceLoader = false;
          },
          (err: HttpErrorResponse) => {
            this.alertMessage(
              'warning',
              'File not uploaded, please check your file'
            );
            setTimeout(() => { }, 3500);
          }
        );
    } else if (this.tabName == 'Judgement') {
      this._selfAssessment3Service
        .UploadEvidenceJudgementT3(
          fileToUpload,
          fileType,
          this.assessmentData.id.toString()
        )
        .subscribe(
          (data: any) => {
            this.fetchSelfAssessmentDocuments();
            this.interpretationEvidanceLoader = false;
          },
          (err: HttpErrorResponse) => {
            this.alertMessage(
              'warning',
              'File not uploaded, please check your file'
            );
            setTimeout(() => { }, 3500);
          }
        );
    } else if (this.tabName == 'Approach') {
      this._selfAssessment3Service
        .UploadEvidenceApproachT3(
          fileToUpload,
          fileType,
          this.assessmentData.id.toString()
        )
        .subscribe(
          (data: any) => {
            this.fetchSelfAssessmentDocuments();
            this.interpretationEvidanceLoader = false;
          },
          (err: HttpErrorResponse) => {
            this.alertMessage(
              'warning',
              'File not uploaded, please check your file'
            );
            setTimeout(() => { }, 3500);
          }
        );
    }
  }
  fetchSelfAssessmentDocuments(): void {
    this.interpretationEvidanceLoader = true;
    if (this.tabName == 'Interpretation') {
      this._selfAssessment3Service
        .getSelfAssessmentT3InterpretationDocument(this.assessmentData.id)
        .subscribe((result: SelfAssessmentDocumentModel[]) => {
          this.selfAssessmentDocument = result;
          this.interpretationEvidanceLoader = false;
        });
    } else if (this.tabName == 'Judgement') {
      this._selfAssessment3Service
        .getSelfAssessmentT3JudgementDocument(this.assessmentData.id)
        .subscribe((result: SelfAssessmentDocumentModel[]) => {
          this.selfAssessmentDocument = result;
          this.interpretationEvidanceLoader = false;
        });
    } else if (this.tabName == 'Approach') {
      this._selfAssessment3Service
        .getSelfAssessmentT3ApproachDocument(this.assessmentData.id)
        .subscribe((result: SelfAssessmentDocumentModel[]) => {
          this.selfAssessmentDocument = result;
          this.interpretationEvidanceLoader = false;
        });
    }
  }
  alertMessage(type: string, message: string): void {
    if (type === 'success') {
      this.toastModel.Title = 'Success';
      this.toastModel.Type = 'success';
    } else {
      this.toastModel.Title = 'Warning';
      this.toastModel.Type = 'warning';
    }
    this.toastModel.Message = message;
    this.isToastShow = true;
    setTimeout(() => {
      this.isToastShow = false;
    }, 3500);
  }
  openDeleteModel(id: number): void {
    if (this.userPermissionList?.UplEvdAction) {
      const dialogRef = this.dialog.open(ModalDialogComponent, {
        data: {
          message: 'Are you sure want to delete?',
          title: 'Delete Document',
          btnText: 'Delete',
        },
      });
      dialogRef.afterClosed().subscribe((data: any) => {
        if (data) {
          this.removeSelfAssessmentDocumentsT3(id);
        }
      });
    }
  }
  removeSelfAssessmentDocumentsT3(id: number) {
    this.interpretationEvidanceLoader = true;
    if (this.tabName == 'Interpretation') {
      this._selfAssessment3Service
        .deleteSelfAssessmentInterpretationT3Document(id)
        .subscribe((data: any) => {
          if (data.result) {
            this.interpretationEvidanceLoader = false;
            this.fetchSelfAssessmentDocuments();
            this.alertMessage('success', data.result);
          }
        });
    } else if (this.tabName == 'Judgement') {
      this._selfAssessment3Service
        .deleteSelfAssessmentJudgementT3Document(id)
        .subscribe((data: any) => {
          if (data.result) {
            this.interpretationEvidanceLoader = false;
            this.fetchSelfAssessmentDocuments();
            this.alertMessage('success', data.result);
          }
        });
    } else if (this.tabName == 'Approach') {
      this._selfAssessment3Service
        .deleteSelfAssessmentApproachT3Document(id)
        .subscribe((data: any) => {
          if (data.result) {
            this.interpretationEvidanceLoader = false;
            this.fetchSelfAssessmentDocuments();
            this.alertMessage('success', data.result);
          }
        });
    }
  }
  downloadDocument(id: number, fileName: string, extension: string) {
    this.interpretationEvidanceLoader = true;
    if (this.tabName == 'Interpretation') {
      this._selfAssessment3Service
        .downloadEvidenceInterpretationT3(id)
        .subscribe(
          (data: any) => {
            this.interpretationEvidanceLoader = false;
            this._globalService.downloadDocument(data, fileName, extension);
          },
          (err: HttpErrorResponse) => {
            console.error(JSON.stringify(err.message));
          }
        );
    } else if (this.tabName == 'Judgement') {
      this._selfAssessment3Service.downloadEvidenceJudgementT3(id).subscribe(
        (data: any) => {
          this.interpretationEvidanceLoader = false;
          this._globalService.downloadDocument(data, fileName, extension);
        },
        (err: HttpErrorResponse) => {
          console.error(JSON.stringify(err.message));
        }
      );
    } else if (this.tabName == 'Approach') {
      this._selfAssessment3Service.downloadEvidenceApproachT3(id).subscribe(
        (data: any) => {
          this.interpretationEvidanceLoader = false;
          this._globalService.downloadDocument(data, fileName, extension);
        },
        (err: HttpErrorResponse) => {
          console.error(JSON.stringify(err.message));
        }
      );
    }
  }
  async editorSave() {
    if (this.ckEditorComponent) {
      for (const editor of this.ckEditorComponent) {
        if (editor?.buttonActive) {
          await editor?.CalledUpdatedSelfAssessmentData();
        }
      }
    }
    this.saveConditionalApprovalsDataWithDataChange();
  }
  async saveConditionalApprovalsData() {
    this.isButtonDisabled = true;
    await this.editorSave();
  }
  saveConditionalApprovalsDataWithDataChange() {
    const conditionalApprovalSaveData:
      | SelfAssessmentInterpretation
      | SelfAssessmentJudgement
      | SelfAssessmentT3ApproachDto = this.assessmentData;
    conditionalApprovalSaveData.actionDueDate =
      conditionalApprovalSaveData.actionDueDate
        ? MasterHelper.bsdatePickerToCorrectDate(
          conditionalApprovalSaveData.actionDueDate.toString()
        )
        : null;
    conditionalApprovalSaveData.actionClosed =
      conditionalApprovalSaveData.actionClosed
        ? MasterHelper.bsdatePickerToCorrectDate(
          conditionalApprovalSaveData.actionClosed.toString()
        )
        : null;
    const dtoData: conditionalApprovalAssessmentData =
      new conditionalApprovalAssessmentData(conditionalApprovalSaveData);
    const currentUrl = window.location.href;
    if (this.tabName == 'Interpretation') {
      this._selfAssessment3Service
        .saveInterpretationT3ConditionalApprovalData(dtoData, currentUrl)
        .subscribe((x) => {
          this.alertMessage(
            'success',
            'Interpretaion conditional approval saved successfully'
          );
          this.isButtonDisabled = false;
          this.afterSave.emit();
        });
    } else if (this.tabName == 'Judgement') {
      this._selfAssessment3Service
        .saveJudgementT3ConditionalApprovalData(dtoData, currentUrl)
        .subscribe((x) => {
          this.alertMessage(
            'success',
            'Judgement conditional approval saved successfully'
          );
          this.isButtonDisabled = false;
          this.afterSave.emit();
        });
    } else if (this.tabName == 'Approach') {
      this._selfAssessment3Service
        .saveApproachT3ConditionalApprovalData(dtoData, currentUrl)
        .subscribe((x) => {
          this.alertMessage(
            'success',
            'Approach conditional approval saved successfully'
          );
          this.isButtonDisabled = false;
          this.afterSave.emit();
        });
    }
    setTimeout(async () => {
      this.userPermissionList = await this._globalService.getUserPermissionList(
        this.assessmentData.id,
        this.versionHistoryData.isVersonHistory,
        this.user,
        this.assessmentData.summaryDetailsId,
        this.tabName
      );
    }, 3500);
  }
  @Output() notifyCkEditorChnage: EventEmitter<any> = new EventEmitter<any>();

  notifyParentCkEditorChnage() {
    this.notifyCkEditorChnage.emit();
  }
}
